function addZore (num) {
  return num >= 10 ? num : '0' + num
}

// 格式化日期-传入时间戳与分隔符
export default function formatDateByTimestamp (timestamp, separator = '-') {
  let time = new Date(timestamp)
  let year = time.getFullYear()
  let month = addZore(time.getMonth() + 1)
  let day = addZore(time.getDate())
  return year + separator + month + separator + day
}



// WEBPACK FOOTER //
// ./src/utils/formatDateByTimestamp.js